<div class="user-group-main">
  <ng-template #backButtonParentRef>
    <!-- dynamic back button render -->
    <ng-content select="[backButton]"></ng-content>
  </ng-template>

  <ng-template #backButtonRef>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor pt-1"
      (click)="closeDialog()"
    />
  </ng-template>

  <ng-template #backButtonChildRef>
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="cross-button pointer-cursor pt-2"
      (click)="childBackButtonHandler()"
    />
  </ng-template>

  <ng-container [formGroup]="formGroup" *ngIf="stepper === 1">
    <app-user-group-listing
      [dialogRef]="dialogRef"
      formGroupName="addUserGroup"
      formGroupDeviceName="deviceGroup"
      (patchFormValues)="patchFormValues($event)"
      (userStepperUpdate)="userStepperUpdate($event)"
      (userSelectedGroup)="userSelectedGroup($event)"
      [(stepper)]="stepper"
      [(userStepper)]="userStepper"
      [(userGroup)]="userGroup"
      (userGroupUpdate)="userGroupUpdate($event)"
      [userGroupList]="userGroupList"
      [skipStepUserType]="skipStepUserType"
      [skipStepBuilding]="skipStepBuilding"
      [isUserProfileFlow]="isUserProfileFlow"
      [buildingList]="buildingList"
      [userName]="userName"
      [alreadySelectedGroups]="alreadySelectedGroups"
    >
      <span backButton>
        <!-- parent button -->
        <ng-template
          *ngIf="userStepper"
          [ngTemplateOutlet]="backButtonParentRef"
        ></ng-template>
        <!-- user group button -->
        <ng-template
          *ngIf="!userStepper"
          [ngTemplateOutlet]="backButtonRef"
        ></ng-template>
      </span>
    </app-user-group-listing>
  </ng-container>

  <ng-container [formGroup]="formGroup" *ngIf="stepper === 2">
    <app-add-user-group
      [class.d-block]
      [isEditMode]="isEditMode"
      (removeUserGroup)="removeUserGroup($event)"
      formGroupName="addUserGroup"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [buildingList]="buildingList"
    >
      <span backButton>
        <!-- parent button -->
        <ng-template
          *ngIf="userStepper"
          [ngTemplateOutlet]="backButtonParentRef"
        ></ng-template>
        <!-- user group button -->
        <ng-template
          *ngIf="!userStepper"
          [ngTemplateOutlet]="backButtonRef"
        ></ng-template>
      </span>
    </app-add-user-group>
  </ng-container>
  <ng-container [formGroup]="formGroup" *ngIf="stepper === 3">
    <app-access-point-buildings
      [class.d-block]
      formGroupName="buildingList"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [buildingList]="buildingList"
      (submitToParent)="incrementStep()"
    >
      <span backButton>
        <!-- parent button -->
        <ng-template
          *ngIf="userStepper"
          [ngTemplateOutlet]="backButtonParentRef"
        ></ng-template>
        <!-- user group button -->
        <ng-template
          *ngIf="!userStepper"
          [ngTemplateOutlet]="backButtonRef"
        ></ng-template>
      </span>
    </app-access-point-buildings>
  </ng-container>
  <ng-container [formGroup]="formGroup" *ngIf="stepper === 4">
    <app-multi-user-selection-list
      [class.d-block]
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      (stepperChange)="disposeStepperChange()"
      (submitSelectedUsers)="submitSelectedUsers($event)"
      [singleUsersSelected]="singleUsersSelected"
      [users]="users"
      [flowType]="CONSTANTS.USER_GROUP"
    >
      <span backButton>
        <!-- parent button -->
        <ng-template [ngTemplateOutlet]="backButtonChildRef"></ng-template>
      </span>
    </app-multi-user-selection-list>
  </ng-container>
</div>
